// @ts-check

import React from "react";
import { useNavigate } from "react-router-dom";
import { IndexTable, Link, Text, Tooltip } from "@shopify/polaris";

import { useFormatCurrency } from "hooks/use-format-currency";

const TRUNCATE_LENGTH = 30;

export const TopParametersTableRow = ({
  data,
  parameterKey,
  calculateParameterReportHref,
  index,
}) => {
  const formatCurrency = useFormatCurrency();
  const navigate = useNavigate();

  const formattedAmount = formatCurrency(data.sum);

  let parameter = data[parameterKey];
  const shouldTruncateValue = data[parameterKey].length > TRUNCATE_LENGTH;

  if (shouldTruncateValue) {
    parameter = (
      <Text as="span">
        {parameter.substring(0, TRUNCATE_LENGTH).trim()}...
      </Text>
    );
  }

  if (calculateParameterReportHref) {
    const handleClick = () => {
      const href = calculateParameterReportHref(data[parameterKey])
      navigate(href);
    }

    parameter = (
      <Link
        onClick={handleClick}
        removeUnderline
      >
        {parameter}
      </Link>
    );
  }

  if (shouldTruncateValue) {
    parameter = (
      <Tooltip content={data[parameterKey]} dismissOnMouseOut>
        {parameter}
      </Tooltip>
    );
  }

  return (
    <IndexTable.Row id={data[parameterKey]} position={index}>
      <IndexTable.Cell>
        {parameter}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" as="span" alignment="end" numeric>
          {new Intl.NumberFormat("en-US").format(data.count)}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" as="span" fontWeight="semibold" alignment="end" numeric>
          {formattedAmount}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};
